import React, { forwardRef, PropsWithChildren } from 'react';
import { filterObject } from './Utilities';

export interface LinkProps extends PropsWithChildren, React.AriaAttributes {
  /** Link */
  href?: string;
  /** Link title */
  title?: string;
  /** Link class name */
  className?: string;
  /** Link target */
  target?: React.HTMLAttributeAnchorTarget;
  /** Link rel */
  rel?: string;
  /** Link role */
  role?: React.AriaRole;
}

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ children, ...props }, ref) => {
    const allowedProps = [
      'href',
      'title',
      'className',
      'target',
      'rel',
      'role',
    ];
    const filteredProps = filterObject(
      props,
      allowedProps,
      [],
      /(aria|data)-.*/,
    );
    return (
      <a ref={ref} {...filteredProps}>
        {children}
      </a>
    );
  },
);
